export const TYPE_AMBIFI_PHONETICS = "ambifi/tts-phonetics";
export const TYPE_AMBIFI_THEME = "ambifi/theme";
export const TYPE_AMBIFI_STYLESHEET = "ambifi/stylesheet";
export const TYPE_AMBIFI_PLAYLISTS = "ambifi/playlists";
export const TYPE_AMBIFI_WORKFLOW_STATES = "ambifi/workflow-states";